import ConfirmResetPasswordForm from './ConfirmResetPasswordForm';

export default ConfirmResetPasswordForm;
